import {Component, Input, Output, SimpleChanges, EventEmitter, ViewChild, ElementRef, forwardRef} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import {SeleccionarDiponiblePipe} from '../../Pipes/SeleccionarDiponible.pipe';
import {SistemaService} from '../../Servicios/Sistema.Service';

declare var $: any;
declare function Focus(id : string) : any;

@Component(
  {
    selector: 'correo',
    templateUrl: './Correo.template.html',
    styleUrls: ['./Correo.scss'],
  })

export class CorreoComponent
{
  @Input() titulo : string = ""; // titulo del input
  @Input() verError : boolean = true;
  @Input() errorActivo : boolean = true;
  @Input() mensajeError : string = "";

  @Output() destinatariosCambio: EventEmitter<any> = new EventEmitter();
  @Output() controlCargado : EventEmitter<any> = new EventEmitter();

  @ViewChild('correoInput') correoInput!: ElementRef;
  @ViewChild('contenedorInput') contenedorInput!: ElementRef;

  public id : number = 0;

  public correoaux : string = "";
  public correoTouched : boolean = false;
  public correos : Array<string> = [];
  public estilo : any = {};
  public focus : boolean = false;

  constructor(public sistemaService : SistemaService)
  {
    this.sistemaService.numeroControl++;
    this.id = this.sistemaService.numeroControl;
    this.correos = [];
  }

  ngOnInit()
  {
  }

  ngAfterViewInit()
  {
    setTimeout(() =>
    {
      this.controlCargado.emit();
    }, 0);

  }

  SetCorreos(correo : string)
  {
    this.correoTouched = false;
    this.correoaux = "";
    this.correos = correo ? correo.split(",") : [];
    this.correos = this.correos.filter(p => {return p});
    this.AjusarDimensionesNuevaEntrada();
  }

  AgregarCorreo(evento : any)
  {
    this.correoTouched = true;

    if(this.correoaux[this.correoaux.length - 1] == "," || this.correoaux[this.correoaux.length - 1] == " ")
    {
      this.correoaux = this.correoaux.slice(0, -1);
    }

    if(evento.code == "Tab")
    {
      setTimeout(() =>
      {
        Focus('correoInput' + this.id);
      }, 100);

    }

    let correoValid = this.correoaux ? this.correoaux.match(this.sistemaService.CorreoER) : false;

    setTimeout(() =>
    {
      this.ValidarCorreoEntrada(this.correoaux);
    }, 1);

    if (!correoValid)
    {
      return;
    }
    else
    {
      let agregado = false;
      for(let c of this.correos)
      {
        if(c.toLowerCase() == this.correoaux.toLocaleLowerCase())
        {
          agregado = true;
        }
      }
      if(!agregado)
      {
        this.correos.push(this.correoaux.toLowerCase());

        var correosAgregados = "";

        this.correos.forEach(correo =>
        {
          correosAgregados += correo + ",";
        });

        this.destinatariosCambio.emit(correosAgregados);
      }

      this.correoaux = "";
      this.AjusarDimensionesNuevaEntrada();
      this.correoTouched = false;
    }
  }

  ValidarCorreoEntrada(entrada : any)
  {
    if(entrada[entrada.length - 1] == "," || entrada[entrada.length - 1] == " ")
    {
      entrada = entrada.slice(0, -1);
    }

    this.correoaux = entrada;

    this.AjusarDimensionesNuevaEntrada();
  }

  AjusarDimensionesNuevaEntrada()
  {
    this.contenedorInput.nativeElement.innerHTML = this.correoInput.nativeElement.value;

    let ancho = (this.contenedorInput.nativeElement.offsetWidth) ? this.contenedorInput.nativeElement.offsetWidth + 8 : 4;

    this.estilo =
    {
      'width': ancho + 'px'
    };

    this.contenedorInput.nativeElement.innerHTML = "";
  }

  QuitarCorreo(index : number)
  {
    var correosAgregados = "";
    this.correos.splice(index, 1);

    this.correos.forEach(correo =>
    {
      correosAgregados += correo + ",";
    });

    this.destinatariosCambio.emit(correosAgregados);
  }

}
